<template>
  <section>
    <ul
      id="plans"
      class="plans d-lg-flex flex-lg-row flex-lg-wrap mb-0 pt-3 list-unstyled"
    >
      <li
        v-for="plan in displayedPlans"
        :key="plan.id"
        class="plan-item d-lg-flex flex-lg-column plan position-relative"
      >
        <PricingItem
          :id="plan.id"
          :is-highlight="plan.highlight"
          :name="generatePlanName(plan)"
          :description="plan.plan_desc"
          :price="plan.price"
          :original-price="plan.original_price"
          :has-all-features="deal.plan_stack_count > 1"
          :features="plan.plan_features"
          :cta-text="pluralizeCode(plan.codes)"
          :tier="plan.tier"
          :show-pricing-info="showPricingInfo"
        >
          <template v-if="showPricingInfo" #cta>
            <AddToCartButton
              :deal="deal"
              :has-plus="hasPlus"
              :additional-text="pluralizeCode(plan.codes)"
              :selected-plan="plan"
            />
          </template>
        </PricingItem>
      </li>
      <li
        v-if="showMoreOptions"
        class="plan-item d-lg-flex flex-lg-column plan position-relative"
      >
        <PricingItem
          :id="dynamicPlan.id"
          :is-highlight="dynamicPlan.highlight"
          :name="generatePlanName(dynamicPlan)"
          :description="dynamicPlan.plan_desc"
          :price="dynamicPlan.price"
          :original-price="dynamicPlan.original_price"
          :has-all-features="deal.plan_stack_count > 1"
          :features="dynamicPlan.plan_features"
          :cta-text="pluralizeCode(dynamicPlan.codes)"
          :tier="dynamicPlan.tier"
          :show-pricing-info="showPricingInfo"
        >
          <template v-if="showPricingInfo" #options>
            <div class="px-3 mb-4">
              <!-- TODO -- Fix Label -->
              <LegacyDropdown
                class="pricing-table"
                highlight
                :value="selectedDeal"
                :options="dealList"
                @selected="updateDeal"
              >
                {{ dropdownPlaceholder }}
              </LegacyDropdown>
            </div>
          </template>
          <template v-if="showPricingInfo" #cta>
            <AddToCartButton
              :deal="deal"
              :has-plus="hasPlus"
              :additional-text="pluralizeCode(dynamicPlan.codes)"
              :selected-plan="selectedPlan || deal.plans[plansToShow - 1]"
            />
          </template>
        </PricingItem>
      </li>
    </ul>
  </section>
</template>

<script>
import get from 'lodash/get';
// TODO:BRO-1276: import Dropdown from dorado
import PricingItem from './PricingItem.vue';

export default {
  components: {
    PricingItem,
    LegacyDropdown: () => import('../../ui/LegacyDropdown.vue'),
    AddToCartButton: () => import('./AddToCartButton.vue'),
  },
  props: {
    deal: {
      type: Object,
      required: true,
    },
    plansToShow: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      selectedDeal: null,
      selectedPlan: null,
      displayedPlans: [],
      showMoreOptions: false,
      dynamicPlan: {},
    };
  },
  computed: {
    showPricingInfo() {
      return !this.deal.stage_details.is_inactive_indefinitely;
    },
    hasPlus() {
      return get(this, ['$store', 'state', 'session', 'user', 'has_plus'], false);
    },
    dropdownPlaceholder() {
      if (this.deal.use_licensing) {
        if (!this.selectedDeal) {
          return 'Select another tier';
        }

        return (this.deal.plans.find((x) => (
          Number(x.id) === Number(this.selectedDeal)
        )) || {}).public_name;
      }

      return (this.selectedDeal) ? `${this.selectedDeal} Codes` : 'Select More Codes';
    },
    dealList() {
      const deals = []; // return different list when useLicesing is true

      for (let i = this.plansToShow; i <= this.deal.plans.length; i += 1) {
        const plan = this.deal.plans[i - 1];

        deals.push({
          display: this.deal.use_licensing ? plan.public_name : `${plan.codes} Codes`,
          value: this.deal.use_licensing ? plan.id : plan.codes,
        });
      }

      return deals;
    },
  },
  created() {
    if (this.deal.plans.length > this.plansToShow) {
      // Since we have more items than the ones we're displaying
      // the last displayed item will change dynamically based on user selection
      this.displayedPlans = this.deal.plans.slice(0, this.plansToShow - 1);

      this.showMoreOptions = true;
      this.dynamicPlan = this.deal.plans[this.plansToShow - 1];
    } else {
      this.displayedPlans = this.deal.plans;
    }
  },
  methods: {
    pluralizeCode(code) {
      if (this.deal.use_licensing) {
        return '';
      }

      return `(${code} code${code > 1 ? 's' : ''})`;
    },
    updateDeal({ value }) {
      let plan = null;
      // TODO -- Make sure working correctly

      if (this.deal.use_licensing) {
        plan = this.deal.plans.find((x) => Number(x.id) === Number(value));
      } else {
        plan = this.deal.plans.find((x) => Number(x.codes) === Number(value));
      }

      this.selectedDeal = value;
      this.selectedPlan = plan;
      this.dynamicPlan = plan;
    },
    generatePlanName(plan) {
      if (plan.public_name) return plan.public_name;
      if (plan.codes > 2) return 'Multiple';
      if (plan.codes === 2) return 'Double';

      return 'Single';
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~/styles/utils/breakpoints';

  .plans {
    margin: 0 -0.5rem;
  }

  .plan-item {
    flex: 0 0 calc(((4 / 12) * 100%) - 1rem);
    margin: 1rem 0.5rem;
    min-width: 12.8rem;
  }

  @include media-breakpoint-up(lg) {
    .plan-item {
      margin-bottom: 0;
      margin-top: 0;
    }

    .title:not([class*='display-']) {
      font-weight: 700 !important;
    }
  }
</style>
